import {CallJs} from "../../lib/types";

type FieldType =
 'c_BirthDate' | 'c_DateCreated' | 'c_LastEdit' | 'membership2_CreatedDate' |
	'membership2_StartDate' | 'membership2_ExpiryDate'

type Operators = {
	id: string,
	name: string,
	value: string,
	field: FieldType,
	text: string,
	queryPage : string,
	operators: {[index: string]: string}
}

export const makeOperators: CallJs<Operators> = (cb, params) => {
	const fragment = document.createDocumentFragment()

	const hidden = document.createElement('input')
	hidden.type = 'hidden'
	hidden.name = params.name
	hidden.value = params.value
	fragment.appendChild(hidden)

	const $field = params.field

	if ($field == 'c_BirthDate' || $field == 'c_DateCreated' || $field == 'c_LastEdit' || $field == 'membership2_CreatedDate' || $field == 'membership2_StartDate' || $field == 'membership2_ExpiryDate') {
		const help = document.createElement('input')
		help.type = 'button'
		help.value = '?'
		help.className = 'helpbutton'
		help.onclick = () => new_window(params.queryPage + '?command=displaySearchDatesHelp&noheaders=1&field=' + $field, 780, 580)
		fragment.appendChild(help)
	}

	const button = document.createElement('input')
	button.type = 'button'
	button.name = 'button_' + params.name
	button.value = params.text
	button.style.color = '#555555'
	//button.style.fontSize = '10px'
	button.style.background = '#FFFFFF'
	button.style.border = '1px solid #DDDDDD'
	button.style.width = '100px'
	//button onclick below due to forward reference
	fragment.appendChild(button)

	fragment.appendChild(document.createElement('br'))

	const operators = document.createElement('div')
	operators.className = 'hide'
	operators.id = params.id
	operators.style.background = "#FFFFFF"
	fragment.appendChild(operators)

	for(const operator_key in params.operators) {
		if(!params.operators.hasOwnProperty(operator_key)) continue;
		const field = document.createElement('div')
		field.style.color = '#000000'
		field.style.fontSize = '12px'
		field.style.background = '#EEEEEE'
		field.style.border = '1px solid #000000'
		field.style.width = '100px'
		field.style.padding = '5px'
		field.style.cursor = 'pointer'
		field.onclick = () => {
			hidden.value = operator_key
			button.value = params.operators[operator_key]
			operators.className = 'hide'
		}
		field.textContent = params.operators[operator_key]
		operators.appendChild(field)
	}

	button.onclick = () => {
		operators.className = operators.className == 'show' ? 'hide' : 'show'
	}

	cb(fragment)

}


// WEBPACK FOOTER //
// ./src/contacts/querybuilder-operators/index.ts